import React, { useState, useEffect } from "react";
import styles from "./sidebar.module.css";
import { useNavigate } from "react-router-dom";
import { useCookies } from "../../../../hooks/useCookies";

import { getProfileSelfieImageUrls } from "../../../../utils/serverUtils";
import { useProfile } from "../../components/context/ProfileContext";

function ProfileCompletion() {
  const { profile,fetchProfile } = useProfile();
  const { getCookie } = useCookies();
  const Navigate = useNavigate();

  const [images2, setImages2] = useState({
    main: null,
    first: null,
    second: null,
  });

  const ImageURL = async (data) => {
    try {
      const profileImages = getProfileSelfieImageUrls(data);
      setImages2(profileImages);
    } catch (error) {
      console.error("Error saving images:", error);
    }
  };

  useEffect(() => {
    if (profile && profile.medias) {
      ImageURL(profile.medias);
    }
  }, [profile]);

  const Username = getCookie("userFullName");

  useEffect(() => {
    if (typeof window === "undefined") return;

    const handleNewImage = async (event) => {
      const success = event.detail;
      if(success){
        const success = await fetchProfile(); 
        const result = success.data;
        ImageURL(result.medias);
      }
    };

    window.addEventListener("imageUpdate", handleNewImage);

    // Cleanup the listener when the component unmounts
    return () => {
      window.removeEventListener("imageUpdate", handleNewImage);
    };
  }, []);

  return (
    <div className={styles.profile}>
      <div
        className={styles.imgContainer}
        style={{
          "--profile-completed": `${profile?.profileCompletion}%`,
        }}
      >
        <div className={styles.innerCircle}>
          <img src={images2.main} alt="" />
        </div>
      </div>
      <p
        style={{
          fontSize: "18px",
        }}
      >
        {Username === "null" ? "Your Name" : Username}
      </p>
      <p
        style={{
          marginTop: "-0.5rem",
          fontSize: "16px",
        }}
      >
        {profile?.profileCompletion}% complete
      </p>
      {profile?.profileCompletion < 100 && (
        <p
          style={{
            fontSize: "16px",
            fontWeight: "500",
            hyphens: "none",
            color: "515151",
          }}
        >
          Complete your profile for better matches
        </p>
      )}
      <button
        className={styles["recommendation"]}
        onClick={() => Navigate("/updateprofile")}
        style={{ fontSize: "16px" }}
      >
        Update
      </button>
    </div>
  );
}

export default ProfileCompletion;
